export default __webpack_public_path__ + "static/media/640_portfolio03-es-mobile.25b9b714.png";